import { Mapper } from "../../../../base/utils/mapper";
import { UserProfileModel } from "../../../../domain/models/user/user-profile.model";
import { UserProfileEntity } from "../entities/user-profile.entity";

export class UserProfileImplementationRepositoryMapper extends Mapper<UserProfileEntity, UserProfileModel> {
    mapFrom(param: UserProfileEntity): UserProfileModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: UserProfileModel): UserProfileEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}
